import { render, staticRenderFns } from "./AlterarTaxaAdmDialog.vue?vue&type=template&id=4b314a42&"
import script from "./AlterarTaxaAdmDialog.vue?vue&type=script&lang=js&"
export * from "./AlterarTaxaAdmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports